import React from 'react';
import { Box, Typography, Button, Stack, Paper, List, ListItem, ListItemText } from '@mui/material';
import { apiUtils } from '../utils/apiUtils';

export default function ErrorsPage() {
  const [events, setEvents] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const isLocal = React.useMemo(() =>
    typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'),
  []);
  const enabled = React.useMemo(() => {
    try {
      const qs = new URLSearchParams(window.location.search);
      if (qs.get('dev') === '1') return true;
      const flag = localStorage.getItem('enableErrorsViewer');
      return isLocal || flag === '1' || flag === 'true';
    } catch { return isLocal; }
  }, [isLocal]);

  const load = async () => {
    try {
      setLoading(true);
      const res = await apiUtils.get('/api/system/client-events').catch(() => ({ success: false }));
      let eventsData = [];
      if (res) {
        if (Array.isArray(res.events)) eventsData = res.events;
        else if (Array.isArray(res?.data)) eventsData = res.data;
        else if (Array.isArray(res?.data?.events)) eventsData = res.data.events;
      }
      setEvents(eventsData);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => { if (enabled) load(); }, [enabled]);

  if (!enabled) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h6" gutterBottom>Errors Viewer Disabled</Typography>
        <Typography variant="body2" color="text.secondary">
          This page is disabled in production. To enable temporarily, add <code>?dev=1</code>
          to the URL or set <code>localStorage.enableErrorsViewer = '1'</code>.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        <Typography variant="h6">Client Errors</Typography>
        <Button onClick={load} disabled={loading} variant="contained">Reload</Button>
      </Stack>
      <Paper variant="outlined" sx={{ p: 1 }}>
        {events.length === 0 ? (
          <Typography variant="body2" color="text.secondary">No errors recorded.</Typography>
        ) : (
          <List dense>
            {events.map((e, i) => (
              <ListItem key={i} alignItems="flex-start">
                <ListItemText primary={e.message || e.error || 'Client error'} secondary={e.timestamp || e.time || ''} />
              </ListItem>
            ))}
          </List>
        )}
      </Paper>
    </Box>
  );
}
